export default __webpack_public_path__ + "static/Poppins-Regular-171106fcd482ec034069837229946bc0.woff";